import React, { useState, useEffect, useContext } from 'react';



import { FcKindle } from "react-icons/fc";

import Loader from '../../../components/loader/loader';
import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';
import { dateFormatter } from '../../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter } from '../../../components/formatters/defFormatter';
import { dateTableFormatter } from '../../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw } from "react-icons/fi";
import { Space, Input, Tag, Button, Spin, Modal, Card, Tabs } from 'antd';
import { selectStyles } from '../../../components/dropDown/selectStyle';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../../init/getData';

import ExcelJS from 'exceljs';


function ImportProducts(props) {

  const { api, userData, categoryOptions, currencyOptions, vatGroupOptions, selectedCompany, refData, selectedYear } = useContext(DataContext);
  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);   
  const [isLoading, setIsLoading] = useState(false);
  const [loadingEffect, setLoadingEffect] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);

  const [category, setCategory] = useState([]);
  const [currency, setCurrency] = useState([]);
  const [vatGroup, setVatGroup] = useState([]);

  const createdBy = parseInt(userData.id);
  const companyId = selectedCompany.id;
  const yearId = selectedYear.id;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataArray = ['category', 'currency', 'vatGroup'];
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  // Function to generate Excel template
  const generateTemplate = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Template');

    // Add header row with the required columns
    worksheet.addRow(['Name', 'Barcode', 'Cost', 'Price', 'Quantity', 'Type']);

    // Create a buffer and download the file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'ProductTemplate.xlsx';
      link.click();
    }).catch((error) => {
      console.error("Error generating template:", error);
      toast.error("Failed to generate template.");
    });
  };

  const handleFileUpload = async (event) => { 
    const file = event.target.files[0];
    if (!file) return;

    const workbook = new ExcelJS.Workbook();
    const reader = new FileReader();

    reader.onload = async (e) => {
        const buffer = e.target.result;
        await workbook.xlsx.load(buffer);
        
        const worksheet = workbook.getWorksheet(1);
        const data = [];

        worksheet.eachRow((row, rowNumber) => {
            if (rowNumber === 1 || !row.values.length) return; // Skip header and empty rows
            const rowData = [];
            row.values.slice(1).forEach(cell => {
                rowData.push(cell ? cell.toString().trim() : "");
            });
            
            if (rowData.length > 0) {
                data.push(rowData);
            }
        });

        console.log('Parsed Data:', data);

        if (!Array.isArray(data) || data.length === 0) {
            toast.error("No valid data found in the uploaded file.");
            return;
        }

        const formattedData = [];  
        const nameSet = new Set();
        const barcodeSet = new Set();
        const duplicateNames = new Set();
        const duplicateBarcodes = new Set();

        data.forEach(row => {
            const product = {
                name: row[0]?.trim().toLowerCase() || "", 
                barcode: row[1] ? row[1]?.toString() : null, 
                categoryId: category?.value || null, // Check for valid category
                currencyId: currency?.value || null, // Check for valid currency
                vatGroupId: vatGroup?.value || null, // Check for valid VAT group
                cost: row[2] || 0,  
                price: row[3] || 0, 
                quantity: row[4] || 0,
                type: row[5] || "",  
                createdBy: createdBy,
                companyId: companyId, 
            };

            // Check for duplicates
            if (nameSet.has(product.name)) {
                duplicateNames.add(product.name);
            } else {
                nameSet.add(product.name);
            }

            if (product.barcode && barcodeSet.has(product.barcode)) {
                duplicateBarcodes.add(product.barcode);
            } else if (product.barcode) {
                barcodeSet.add(product.barcode);
            }

            formattedData.push(product);
        });

        // Show toast error if there are duplicates
        if (duplicateNames.size > 0 || duplicateBarcodes.size > 0) {
            let errorMessage = "Duplicate entries found:\n";
            if (duplicateNames.size > 0) {
                errorMessage += `Duplicate Names: ${[...duplicateNames].join(", ")}\n`;
            }
            if (duplicateBarcodes.size > 0) {
                errorMessage += `Duplicate Barcodes: ${[...duplicateBarcodes].join(", ")}`;
            }
            toast.error(errorMessage);
            return;
        }

        let successCount = 0;

        // Now insert products since there are no duplicates
        for (let product of formattedData) {
            try {
                let res = await api.post(`product/add`, { product });
                console.log("Response:", res?.data);
                if (res.status === 200 ) {
                  successCount++;
                } else {
                    toast.error(`Error adding ${product.name}: ${res?.data.message}`);
                }
            } catch (error) {
                console.error("API Error:", error.response?.data || error.message);
                toast.error(`Failed to add ${product.name}`);
            } finally {
                setLoadingEffect(false);
            }

            if (successCount > 0) {
              toast.success(`${successCount} products added successfully!`);
          }
        }
    };

    reader.readAsArrayBuffer(file);
};




  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

      <Spin spinning={loadingEffect} fullscreen />

      <Card style={{ textAlign: 'center', width: '600px' }}>
        <p>
          This method will recalculate the quantity of each product across warehouse.<br />
          Please note that this process may take some time to complete.
        </p>

        <Row className="mb-4">
          <Col md={3}>
            Category
          </Col>
          <Col md={6}>
            <Select  
              styles={selectStyles}
              options={Array.isArray(categoryOptions) ? categoryOptions : []} 
              isSearchable={true}
              placeholder="Select Category"
              onChange={setCategory}
              value={category}
              required
            />
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={3}>
            Currency
          </Col>
          <Col md={6}>
            <Select
              styles={selectStyles}
              options={Array.isArray(currencyOptions) ? currencyOptions : []}
              isSearchable={true}
              placeholder="Select Currency"
              onChange={setCurrency}
              value={currency}
              required
            />
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={3}>
            VatGroup
          </Col>
          <Col md={6}>
            <Select
              styles={selectStyles}
              options={Array.isArray(vatGroupOptions) ? vatGroupOptions : []}
              isSearchable={true}
              placeholder="Select VatGroup"
              onChange={setVatGroup}
              value={vatGroup}
              required
            />
          </Col>
        </Row>

        <Row>
          <Col md={4}></Col>
          <Col md={4}>
          <Button 
              style={{ backgroundColor: '#23576a', color: 'white' }} 
              onClick={generateTemplate}
            >
              Download Excel Template
            </Button>
            <Button 
              style={{ backgroundColor: '#23576a', color: 'white' }} 
              onClick={() => document.getElementById('file-input').click()}
            >
              Import Excel
            </Button>
            <input 
              id="file-input"
              type="file" 
              accept=".xlsx" 
              onChange={handleFileUpload} 
              style={{ display: 'none' }}
            />
          </Col>
        </Row>
      </Card >
    </div>
  )
}

export default ImportProducts;